export const orderGameweeks = gameweeks => {
  return gameweeks.map(item => {
    if (item.gameweeks.length > 1) {
      const gameweeksOrdered = item.gameweeks.sort((a, b) =>
        a.number > b.number ? 1 : -1
      );

      return { ...item, gameweeks: gameweeksOrdered };
    }
    return item;
  });
};
